import Check16 from '../../assets/icons/16/Check_16.vue.js';

//
var script = {
  name: 'CheckboxControl',
  components: {
    Check16: Check16
  },
  model: {
    prop: 'checked',
    event: 'change'
  },
  inject: {
    formItem: {
      default: ''
    }
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    indicatorPosition: {
      type: String,
      default: 'left' // left, right

    },
    name: {
      type: String,
      default: ''
    },

    /**
     * @deprecated since version 3.0.0
     */
    textError: {
      type: String,
      default: '',

      validator: function validator(value) {
        if (value) {
          console.warn('InputControl or TextareaControl: Props "textError" is deprecated, use component "FormItem" for textError or prop "isError"');
        }

        return true;
      }

    }
  },
  computed: {
    rootClass: function rootClass() {
      return {
        '_indicator-right': this.indicatorPosition === 'right',
        '_error': this.isErrorDI
      };
    },

    isErrorDI: function isErrorDI() {
      return this.formItem ? !!this.formItem.textError : !!this.textError;
    },

    textErrorDI: function textErrorDI() {
      return this.formItem ? '' : this.textError;
    }

  },
  methods: {
    handlerChange: function handlerChange(event) {
      this.$emit('change', event.target.checked);
    }

  }
};

export default script;
